module.exports = __webpack_public_path__ + "static/media/list.e2cb87c8.svg";